import { Injectable } from "@angular/core";

// App
import { IsEnabled, IsSupported, OrderGetterSetter } from "./storage-service";
import { Order } from "../order/order";

@Injectable({
    providedIn: "root",
})
export class OrderMemoryStorageService
    implements IsEnabled, IsSupported, OrderGetterSetter {
    private orderStore_: Order;

    public get isSupported() {
        return true;
    }

    public get isEnabled() {
        return this.isSupported;
    }

    public get order(): Order {
        return this.orderStore_;
    }

    public set order(order: Order) {
        this.orderStore_ = order;
    }
}
